import { formatRial } from '@kia/shared';

/** Right-aligned, thousands-separated Rial with the ﷼ sign; em-dash for null. */
export function Money({ value }: { value: number | null | undefined }) {
  return <span className="num">{formatRial(value)}</span>;
}
